import React, { Component } from "react";

import classNames from 'classnames';

class Introduction extends Component {

    constructor() {

        super();

        this.glitch = this.glitch.bind(this);
        this.glitchTimer = this.glitchTimer.bind(this);
        this.resetGlitch = this.resetGlitch.bind(this);

        this.state = {
            profileGlitchNumber: 0,
            textGlitchNumber: 0
        };

    }

    glitch() {
        console.log("glitch");

        this.setState({
            profileGlitchNumber: Math.ceil(Math.random() * 10),
            textGlitchNumber: Math.ceil(Math.random() * 3)
        });

    }

    resetGlitch() {
        console.log("RESET GLITCH");

        this.setState({
            profileGlitchNumber: 0,
            textGlitchNumber: 0
        });

    }

    glitchTimer() {

        (Math.floor(Math.random() * 10) % 3) === 0 ? this.glitch() : this.resetGlitch();

    }

    componentDidMount() {
        //console.log("componentDidMount");

        setInterval(this.glitchTimer, 500);
    }

    render() {

        return (

            <div className={classNames("section","introduction")}>
            
                <div className="introduction-text">
                    <div className="introduction-small">
                        <span>&#9995;</span> Howdy! I'm Gray Gunter.
                    </div>

                    <div className="introduction-large">
                        I'm a&nbsp;
                        <span className={classNames("introduction-highlight",  (this.state.textGlitchNumber === 1) ? "with-glitch" : null)}>
                            UX/UI designer&nbsp;
                        </span> 
                        and&nbsp;
                        <span className={classNames("introduction-highlight",  (this.state.textGlitchNumber === 2) ? "with-glitch" : null)}>
                            front-end web developer&nbsp;
                        </span>
                        with over&nbsp; 
                        <span className={classNames("introduction-highlight",  (this.state.textGlitchNumber === 3) ? "with-glitch" : null)}>
                            {new Date().getFullYear() - 2008} years of experience
                        </span>
                        .
                    </div>

                    <div className="introduction-details">
                        Based in Columbia, South Carolina, I have worked with private companies of all sizes and government agencies on projects large and small. I have worked on-site, remotely and traveling to clients. I enjoy designing and coding. When people ask me what I do for a living I usually reply, “…stuff on the internet.” 
                    </div>
                </div>
                <div                 
                    className={classNames("profile", "glitch" + this.state.profileGlitchNumber)}>
                </div>
            </div>
        );
    
    }

}

export default Introduction;